// extracted by mini-css-extract-plugin
module.exports = {"container":"ApiMethod-module--container--llH_t","marker":"ApiMethod-module--marker--cuoMI"};